import { Buffer } from 'buffer';
import { DateTime } from 'luxon';

import { PQFLAnswerItem } from '../../page';

// Após adaptar o gerador de PDF do html2pdf para a biblioteca react-pdf, foi notado que a imagem no banco é armazenada no formato BMP,
// incompatível com a ferramenta. Essa função faz a conversão para png. A função é utilizada ao carregar as imagens de Logo e Assinaturas.
export function processImage(rawImage: any): Promise<string | undefined> {
  return new Promise(resolve => {
    if (!rawImage) {
      resolve(undefined);
      return;
    }
    try {
      const content = rawImage.data ? rawImage.data : rawImage;
      const base64Str = Buffer.from(content).toString('utf8').trim();
      const img = new Image();
      img.src = `data:image/bmp;base64,${base64Str}`;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        if (ctx) {
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL('image/png'));
        } else resolve(undefined);
      };
      img.onerror = () => resolve(undefined);
    } catch (e) {
      resolve(undefined);
    }
  });
}
// modifica o formarto da resposta de acordo com o tipo da pergunta do questionário
export function getAnswerValue(item: PQFLAnswerItem) {
  if (item.tipo_pergunta === 1) return item.valor === 'S' ? 'Sim' : 'Não';
  if (item.tipo_pergunta === 3) {
    return DateTime.fromISO(item.valor).isValid
      ? DateTime.fromISO(item.valor).toFormat('dd/MM/yyyy')
      : item.valor;
  }
  if (item.tipo_pergunta === 4) {
    return DateTime.fromISO(item.valor).isValid
      ? DateTime.fromISO(item.valor).toFormat('HH:mm')
      : item.valor;
  }
  return item.valor;
}
